import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ProjectMeta } from '../../../projects/project.model';
import _ from 'lodash';
import { convertProjectStatus, haveMoreUnpublishedPatternChanges } from '../project-status.helper';
import { PatternVersionInfo } from '../../../version-control/pattern-meta-info.model';

@Component({
    selector: 'adm4-project-summary-changes',
    template: `
    <adm4-project-summary-section [title]='"Last unpublished changes"'>
      @if (displayLastUnpublishedChanges) {
        <ul class='changes-group-list'>
          @for (groups of unpublishedChanges; track groups) {
            @for (group of groups; track group) {
              @if (isString(group)) {
                <li>{{group}}</li>
              } @else {
                <ul class='changes-list'>
                  @for (patternInfo of group; track patternInfo) {
                    <li>
                      {{patternInfo.name}} - {{patternInfo.localStatus | capitalizeFirst}} by {{patternInfo.localAuthor}}, {{patternInfo.localDate | customDate}}
                    </li>
                  }
                </ul>
              }
            }
          }
        </ul>
        @if (haveMoreUnpublishedChanges) {
          <a (click)='toggleShowAll()'>{{showLinkText}}</a>
        }
      } @else {
        None
      }
    </adm4-project-summary-section>
    `,
    styleUrls: ['./project-summary-changes.component.scss', '../project-summary-section.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProjectSummaryChangesComponent implements OnChanges {
  @Input() projectStatusModel: ProjectMeta;

  dateFormat = 'HH:mm';
  unpublishedChanges: Array<string | Array<PatternVersionInfo>>;
  haveMoreUnpublishedChanges: boolean;
  showLinkText: string;
  lastUnpublishedChanges: Array<string | Array<PatternVersionInfo>>;
  allUnpublishedChanges: Array<string | Array<PatternVersionInfo>>;
  private showingAllUnpublishedChanges: boolean;
  /** Last unpublished changes should show last 8 changes. */
  private readonly lastUnpublishedChangeLimit = 8;

  isString(value: any): boolean {
    return _.isString(value);
  }

  get displayLastUnpublishedChanges(): boolean {
    return !!this.lastUnpublishedChanges && !!this.lastUnpublishedChanges.length;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['projectStatusModel']) {
      this.lastUnpublishedChanges = convertProjectStatus(this.projectStatusModel, this.lastUnpublishedChangeLimit);
      this.allUnpublishedChanges = convertProjectStatus(this.projectStatusModel);

      this.unpublishedChanges = this.lastUnpublishedChanges;
      this.showLinkText = 'Show all';

      this.haveMoreUnpublishedChanges = haveMoreUnpublishedPatternChanges(this.projectStatusModel, this.lastUnpublishedChangeLimit);
    }
  }

  toggleShowAll(): void {
    if (!this.showingAllUnpublishedChanges) {
      this.unpublishedChanges = this.allUnpublishedChanges;
      this.showLinkText = 'Show less';
    } else {
      this.showLinkText = 'Show all';
      this.unpublishedChanges = this.lastUnpublishedChanges;
    }

    this.showingAllUnpublishedChanges = !this.showingAllUnpublishedChanges;
  }
}
